import { ADD_PROPERTY_SUCCESS, DELETE_PROPERTY_SUCCESS, GET_PROPERTIES_SUCCESS, MODAL_PROPERTY_SHOW, 
    UPDATE_PROPERTY_SUCCESS, PROPERTY_SAVED, UPLOAD_IMAGES_PROPERTY_SUCCESS, SET_PROPERTY,
    GET_PROPERTY_GET_QR_SUCCESS,MODAL_PROPERTY_DELETE_SHOW,
    SET_PROPERTY_QR
} from "./actions";

const INIT_STATE = {
    properties: [],
    totalItems:0,
    propertyModalShow:false,
    error: {},
    propertySaved: false, 
    propertyDeletedModalShow: false,
    propertyDeleted: false,
    property: {},
    uploadImagesFlagSuccess:false,
    propertyQr:null,
    propertygetQrSuccess:false
};


const PropertyReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PROPERTIES_SUCCESS:
            return {
                ...state,
                properties: action.payload.data.data,
                totalItems: action.payload.data.total,
            };
        case ADD_PROPERTY_SUCCESS:
                return {
                  ...state,
                    properties: action.payload.data.list.data,
                    totalItems: action.payload.data.list.total,
                    propertySaved: action.payload.success,
                    property: action.payload.data.property
                };
        case UPDATE_PROPERTY_SUCCESS:
                return {
                    ...state,
                    properties: action.payload.data.data,
                    propertySaved: action.payload.success,
                    totalItems: action.payload.data.total,
            };
        case UPLOAD_IMAGES_PROPERTY_SUCCESS:
                return {
                    ...state,
                    uploadImagesFlagSuccess:action.payload,
                };
        case DELETE_PROPERTY_SUCCESS:
            console.info(action.payload.data)
                return {
                    ...state,
                    properties: action.payload.data.data,
                    totalItems: action.payload.data.total,
                    propertyDeleted: action.payload.success
                }
        case MODAL_PROPERTY_SHOW:
                return {
                    ...state,
                    propertyModalShow: action.payload,
                }
        case PROPERTY_SAVED:
                return {
                    ...state,
                    propertySaved: action.payload
                }
        case SET_PROPERTY:
                return {
                    ...state,
                    property: action.payload
                }
        case SET_PROPERTY_QR:
                return {
                    ...state,
                    propertyQr: action.payload,
                    propertygetQrSuccess: true,
                }
        case GET_PROPERTY_GET_QR_SUCCESS:
                return {
                    ...state,
                    propertygetQrSuccess: action.payload,
                }
        case MODAL_PROPERTY_DELETE_SHOW:
                return {
                    ...state,
                    propertyDeletedModalShow: action.payload,
                }
        default:
            return state;
    }
};

export default PropertyReducer;